import EmptyState from "./EmptyState";
import LTR from "./LTR";
import { secEmptyState } from "../utils/secStatus";

// ─── A company panel with nothing to show yet (21/10/2026) ──────────────────
// What the SEC sync says about the symbol (utils/secStatus.js): still loading,
// a failed attempt that will be retried, or not in SEC's directory. Never a
// claim that the company does not file.
export default function SecEmpty({ symbol, status, icon = "clipboard" }) {
  const s = secEmptyState(status);
  const line = s.kind === "not_found"
    ? <>{s.line} <LTR>{symbol}</LTR></>
    : s.kind === "failed"
      ? <>{s.line} של <LTR>{symbol}</LTR></>
      : <>{s.line} · <LTR>{symbol}</LTR></>;
  return <EmptyState icon={icon} line={line} sub={s.sub}/>;
}
